<template>
  <PlatformRenderer>
    <template v-slot:onDesktop>
      <!-- START : Product Details Desktop -->
      <div class="shopping-list-product row pl-4 col-8 col-md-9 ">
        <div class="col-5 col-xl-6">
          <!-- START : Product Name -->
          <router-link
            :to="`/i/${listItem.item.id}`"
            class="wc-item-name underline-link-from-center px-0 mx-2 col-5 col-xl-6"
            :id="listItem.item.id"
          >
            {{ listItem.item.name }}
          </router-link>
          <!-- END : Product Name -->
          <!-- START : Linked Items -->
          <div class="col-10">
            <WCLinkedItems
              v-if="listItem.variation && listItem.variation.modifiers"
              :listItem="listItem"
            />
          </div>
          <!-- END : Linked Items -->
        </div>
        <!-- START : Product Btn Section -->
        <div class="btn-section col-5 col-xl-4 flex-1 px-1" v-if="!listViewScanMode">
          <WCBasicAddToCartButton
            v-if="
              !(listItem.item.hasModifiers || listItem.item.hasLinkedItems) &&
                $configuration.cartEnabled
            "
            :item="listItem.item"
            :variation="listItem.variation"
            class="btn-block w-100"
            :describedBy="listItem.item.id"
          />
          <WCCustomizeButton
            v-else-if="
              (listItem.item.hasModifiers || listItem.item.hasLinkedItems) &&
                $configuration.cartEnabled
            "
            class="btn btn-block w-100"
            :item="listItem.item"
          />
          <WCAddToListButton
            v-else-if="!$configuration.cartEnabled"
            class="btn-block w-100"
            :item="listItem.item"
            :describedBy="listItem.item.id"
          />
          <WCItemModifierAddToCartQuantityAdjuster
            class="btn-block w-100"
            v-else
            :item="listItem.item"
            :variation="listItem.variation"
            :editingItem="false"
            :describedBy="listItem.item.id"
          />

          <button
            class="btn btn-link wc-remove-item__button link-primary text-body border-primary ml-3 font-size-sm"
            @click="remove(listItem.item, variation)"
            v-if="hasRemove"
            :aria-label="$t('remove')"
            :aria-describedby="listItem.item.id"
          >
            <font-awesome-icon icon="trash" />
          </button>
        </div>
        <!-- END : Product Btn Section -->

        <!-- START : Product Price Section -->
        <div class="col-2 shopping-list-product__price d-flex flex-column">
          <WCProductPricing
            v-if="listItem.item && !listItem.variation"
            :item="listItem.item"
          ></WCProductPricing>
          <span class="font-weight-bold" v-else> {{ mtoItemPrice | currency }}</span>
          <span class="font-size-xs" v-if="listItem.quantity && showQuantity"
            >{{ $t('quantityAbbr') }} {{ listItem.quantity }}</span
          >
        </div>
        <!-- END : Product Price Section -->
      </div>
      <!-- END : Product Details Desptop-->
    </template>

    <!-- START: Mobile View - Shopping List -->
    <template v-slot:onMobile>
      <div class="wc-product-details-wrap mt-2 col-7">
        <!-- START: Product Details -->
        <div class="wc-cart-items-details d-flex mb-3">
          <!-- START : Product Name -->
          <div class=" col-8 px-0 ">
            <router-link
              :to="`/i/${listItem.item.id}`"
              class="wc-item-name underline-link-from-center text-dark text-break"
              :id="listItem.item.id"
              v-if="!scanMode"
            >
              {{ listItem.item.name }}
            </router-link>
            <div
              v-else
              class="wc-item-name text-dark"
              :class="{ 'text-line-through': listItem.isSelected }"
            >
              {{ listItem.item.name }}
            </div>
            <!-- START: Product Variation -->
            <WCLinkedItems
              v-if="listItem.variation && listItem.variation.modifiers"
              :listItem="listItem"
            />
            <!-- END: Product Variation -->
          </div>
          <!-- START : Product Name -->

          <!-- START : Product Price Section -->
          <div class="col-4 pr-0 d-flex justify-content-end">
            <WCProductPricing
              v-if="listItem.item && !listItem.variation"
              :item="listItem.item"
              :price="listItem.price"
            ></WCProductPricing>
            <span class="font-weight-bold" v-else> {{ mtoItemPrice | currency }}</span>
          </div>
          <!-- END : Product Price Section -->
        </div>
        <!-- END: Product Details -->
        <div
          class="wc-cart-add-remove-buttons-wrap mt-3 d-sm-flex"
          :class="listViewScanMode ? 'justify-content-end' : 'justify-content-between'"
          v-if="!scanMode"
        >
          <div class="remove-btn-wrap" v-if="hasRemove">
            <button
              class=" mx-0 btn btn-link underline-link-from-center wc-remove-item__button link-primary text-right"
              @click="remove(listItem.item, variation)"
            >
              <font-awesome-icon class="mr-1" icon="trash" /> {{ $t('remove') }}
            </button>
          </div>
          <template v-if="!listViewScanMode">
            <WCBasicAddToCartButton
              v-if="
                !(listItem.item.hasModifiers || listItem.item.hasLinkedItems) &&
                  $configuration.cartEnabled
              "
              :item="listItem.item"
              :variation="listItem.variation"
              :linkButtonType="true"
            />
            <WCCustomizeButtonMobile
              v-else-if="
                (listItem.item.hasModifiers || listItem.item.hasLinkedItems) &&
                  $configuration.cartEnabled
              "
              :item="listItem.item"
            />
            <WCAddToListButtonMobile
              v-else-if="!$configuration.cartEnabled"
              class="mx-auto"
              :item="listItem.item"
              :showText="false"
            />
            <WCItemModifierAddToCartQuantityAdjuster
              v-else
              :item="listItem.item"
              :variation="listItem.variation"
              :editingItem="false"
              :linkButtonType="true"
            />
          </template>

          <span class="font-size-xs" v-if="listItem.quantity && showQuantity"
            >{{ $t('quantityAbbr') }} {{ listItem.quantity }}</span
          >
        </div>
      </div>
    </template>
    <!-- END: Mobile View - Shopping List -->
  </PlatformRenderer>
</template>
<script>
import WCProductPricing from '@/components/WCProductPricing/WCProductPricing.vue';
import PlatformRenderer from '@/modules/platform/components/PlatformRenderer';
import WCBasicAddToCartButton from '@/modules/cart/components/WCBasicAddToCartButton/WCBasicAddToCartButton.vue';
import WCItemModifierAddToCartQuantityAdjuster from '@/modules/itemModifiers/components/WCItemModifierAddToCartQuantityAdjuster/WCItemModifierAddToCartQuantityAdjuster.vue';
import WCLinkedItems from '@/modules/cart/components/WCLinkedItems/WCLinkedItems.vue';
import WCAddToListButton from '@/modules/lists/components/WCAddToListButton/WCAddToListButton.vue';
import WCAddToListButtonMobile from '@/modules/lists/components/WCAddToListButtonMobile/WCAddToListButtonMobile.vue';
import WCCustomizeButton from '@/modules/cart/components/WCCustomizeButton/WCCustomizeButton.vue';
import WCCustomizeButtonMobile from '@/modules/cart/components/WCCustomizeButton/WCCustomizeButtonMobile.vue';

export default {
  name: 'WCListProductDetails',
  props: {
    listItem: {
      type: Object,
      required: true,
    },
    hasRemove: {
      type: Boolean,
      default: true,
    },
    scanMode: {
      type: Boolean,
      default: false,
    },
    listViewScanMode: {
      type: Boolean,
    },
    showQuantity: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    WCProductPricing,
    PlatformRenderer,
    WCBasicAddToCartButton,
    WCItemModifierAddToCartQuantityAdjuster,
    WCLinkedItems,
    WCAddToListButton,
    WCAddToListButtonMobile,
    WCCustomizeButton,
    WCCustomizeButtonMobile,
  },
  computed: {
    variation() {
      return this.listItem.variation && this.listItem.variation.id
        ? this.listItem.variation.id
        : this.listItem.variation;
    },
    mtoItemPrice() {
      if (this.listItem.item) {
        return this.listItem.variation && this.listItem.variation.priceOfModifiers
          ? this.listItem.variation.priceOfModifiers + this.listItem.item.actualPrice
          : this.listItem.item.actualPrice;
      }
      return 0;
    },
  },
  emits: ['remove'],
  methods: {
    /**
     * Method to emit remove from shopping list Event
     * @param item - Object - Item object
     * @param variation - String - Variation String
     */
    async remove(item, variation) {
      this.$emit('remove', { item, variation });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/assets/styles/_tools.scss';
@import '~@/assets/styles/_settings.scss';

.wc-cart-items-details {
  display: flex;
  align-items: center;
}

/*---- START : Desktop Shopping List Product  ----*/
.shopping-list-product {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 0.75rem;

  & .btn-section {
    display: flex;
  }

  &__price {
    padding-right: 0;
  }

  @include media-breakpoint-down(lg) {
    & .wc-item-name {
      width: 16rem;
    }
  }

  @include media-breakpoint-up(xl) {
    & .wc-item-name {
      width: 20rem;
    }
  }
}
/*---- END : Desktop Shopping List Product  ----*/

/*---- START : Mobile Shopping List Product  ----*/
.shopping-list-product--mobile {
  display: flex;
  flex-direction: column;
  justify-content: center;
  & .wc-item-name {
    width: 100%;
  }
}

.text-line-through {
  text-decoration: line-through;
}
/*---- END : Mobile Shopping List Product  ----*/

@include media-breakpoint-down(sm) {
  .wc-remove-item__button {
    min-width: 6rem;
  }
}
</style>
